export default "__VITE_ASSET__C19RH1DL__"